export default __webpack_public_path__ + "static/media/aspire_sh_light.83ce63d7.png";